<template>
    <div id="notifications-template">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Generate Activation',
                    to: { path: '/code-activation' },
                },
                { text: 'Tambah Kode Aktivasi' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Tambah Kode Aktivasi</h3>

        <v-card flat>
            <v-card-title>
                Tambah Kode Aktivasi <v-spacer></v-spacer>

                <!-- <v-btn
          depressed
          rouded
          small
          class="pa-2"
          height="33px"
          color="#EC675E"
          style="min-width: 0 !important"
        >
          <v-icon color="white" style="font-size: 20px">
            mdi-delete-outline
          </v-icon>
        </v-btn> -->
            </v-card-title>
            <v-divider />
            <v-card-text>
                <template v-if="page === 'form'">
                    <v-form ref="form">
                        <div class="mb-2 mt-4">
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Jumlah User *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Jumlah User"
                                        v-model="form.count"
                                        outlined
                                        required
                                        :rules="[
                                            (v) =>
                                                !!v ||
                                                'Jumlah user wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Durasi *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Durasi (Bulan)"
                                        v-model="form.duration"
                                        outlined
                                        :rules="[
                                            (v) => !!v || 'Durasi wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Jenjang *
                                    </v-list-item-title>

                                    <div>
                                        <v-btn
                                            depressed
                                            rounded
                                            v-for="(data, index) of level_list"
                                            class="mb-5 mr-2"
                                            width="60"
                                            :color="
                                                level === data ? 'success' : ''
                                            "
                                            @click="level = data"
                                            :key="index"
                                        >
                                            {{ data }}
                                        </v-btn>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Kelas *
                                    </v-list-item-title>

                                    <div>
                                        <v-btn
                                            depressed
                                            rounded
                                            v-for="(data, index) of grade_list"
                                            class="mb-5 mr-2"
                                            width="50"
                                            :color="
                                                grade === data ? 'primary' : ''
                                            "
                                            :key="index"
                                            @click="grade = data"
                                        >
                                            {{ data }}
                                        </v-btn>
                                    </div>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Paket *
                                    </v-list-item-title>

                                    <v-autocomplete
                                        placeholder="Pilih Paket"
                                        outlined
                                        class="pa-0"
                                        v-model="form.package_id"
                                        :items="data_package"
                                        item-text="name"
                                        item-value="id"
                                        :rules="[
                                            (v) => !!v || 'Paket wajib diisi',
                                        ]"
                                    ></v-autocomplete>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Platform *
                                    </v-list-item-title>

                                    <v-text-field
                                        placeholder="Platform"
                                        v-model="form.platform"
                                        outlined
                                        :rules="[
                                            (v) =>
                                                !!v || 'Platform wajib diisi',
                                        ]"
                                    />
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Tanggal Expired *
                                    </v-list-item-title>

                                    <v-menu
                                        ref="menu"
                                        v-model="date_expired"
                                        :close-on-content-click="false"
                                        transition="slide-y-reverse-transition"
                                        offset-y
                                        min-width="auto"
                                    >
                                        <template
                                            v-slot:activator="{ on, attrs }"
                                        >
                                            <v-text-field
                                                v-model="form.expired_at"
                                                append-icon="mdi-calendar"
                                                placeholder="Tanggal Expired"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                outlined
                                                :rules="[
                                                    (v) =>
                                                        !!v ||
                                                        'Tanggal expired wajib diisi',
                                                ]"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                            v-model="form.expired_at"
                                            no-title
                                            scrollable
                                            @change="date_expired = false"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-list-item-content>
                            </v-list-item>
                        </div>

                        <v-row class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                @click="$router.push('/code-activation')"
                                class="mr-2"
                            >
                                Batal
                            </v-btn>
                            <v-btn
                                color="primary"
                                depressed
                                @click="submitActivationCode()"
                                :loading="isLoading"
                            >
                                Lanjut
                            </v-btn>
                        </v-row>
                    </v-form>
                </template>

                <template v-if="page === 'download'">
                    <div class="text-center">
                        <div class="mb-5 mt-3 font-weight-bold black--text">
                            Anda telah berhasil menambahkan kode aktivasi
                        </div>
                        <v-btn
                            id="datatable_detail_btn"
                            depressed
                            large
                            color="#E8F5FA"
                            class="font-weight-bold"
                            style="color: #2690cb"
                            @click="downloadFile()"
                        >
                            <v-icon class="mr-2"> mdi-tray-arrow-down </v-icon>
                            Download Kode Aktivasi
                        </v-btn>
                    </div>
                    <v-row class="pa-4">
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            depressed
                            @click="$router.push('/code-activation')"
                        >
                            Selesai
                        </v-btn>
                    </v-row>
                </template>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import axios from "axios";
import moment from "moment";

export default {
    name: "notifications-template",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            token: JSON.parse(localStorage.getItem("token")).value,
            isLoading: false,
            data: [],
            form: {
                jumlah_user: null,
                kelas: null,
                paket: null,
            },
            page: "form",
            form: {
                count: null,
                duration: null,
                package_id: null,
                grade: null,
                level: null,
                platform: null,
                expired_at: null,
            },
            level: "SD",
            grade: 6,
            expired_date: null,
            data_package: null,
            date_expired: false,
            level_list: ["SD", "SMP", "SMA"],
            grade_list: [1, 2, 3, 4, 5, 6],
            response: null,
        };
    },

    watch: {
        level: function (val) {
            if (val === "SMA") {
                this.grade_list = [10, 11, 12];
            } else if (val === "SMP") {
                this.grade_list = [7, 8, 9];
            } else if (val === "SD") {
                this.grade_list = [1, 2, 3, 4, 5, 6];
            }
        },
    },

    computed: {},

    mounted: function () {
        this.fetchData();
        this.getPackage();
    },

    methods: {
        fetchData() {
            const context = this;
            const param = ``;
            const url = `${process.env.API_BASE_URL}liveclass/admin/list-reports${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data = response.data;
                }
            });
        },

        getPackage() {
            const context = this;
            const url = `${process.env.API_BASE_URL}payment/package/getallpackage`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    context.data_package = response.data;
                }
            });
        },

        async submitActivationCode() {
            const context = this;
            const url = `${process.env.API_BASE_URL}account/code/generate`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            context.form.level = context.level;
            context.form.grade = context.grade;

            if (context.$refs.form.validate()) {
                context.isLoading = true;
                context.form.expired_at = moment(
                    context.form.expired_at,
                ).format("DD-MM-YYYY");

                try {
                    await axios
                        .post(url, context.form, options)
                        .then(function (response) {
                            if (response.status === 200) {
                                context.response = response.data;
                                context.page = "download";
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal memproses generate kode aktivasi, Kuota sudah melebihi batas`,
                                    type: "error",
                                });
                            }
                            context.isLoading = false;
                        });
                } catch (error) {
                    context.$store.commit("showAlert", {
                        message: `Gagal memproses generate kode aktivasi`,
                        type: "error",
                    });
                    context.isLoading = false;
                }
            }
        },
        downloadFile() {
            const context = this;
            const param = `document_url=${context.response.file_url}`;
            const url = `${process.env.API_BASE_URL}partnership/admin/partner/download/documentation?${param}`;

            const authToken = context.token;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            axios.get(url, options).then(function (response) {
                if (response.status === 200) {
                    var url = response.data.download_url;
                    window.open(url, "_blank");
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// CodeActivationForm.vue?5ac2f030